import { otmsHttp, wmsHttp } from '@/utils/http/index.js'

/**
 * 货主SKU分页
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8750
 */
export function fetchSkuPage(data, params) {
    return otmsHttp.request({
        url: '/customer/sku/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 货主SKU分页 wms货品查询
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8750
 */
export function fetchSkuPageWms(data, params) {
    return otmsHttp.request({
        url: '/base_plus/sku/page',
        method: 'post',
        data,
        params
    })
}
/**
 * 货主SKU分页 wms货品查询
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/11442
 */
export function warehouseGoods(data, params) {
    return otmsHttp.request({
        url: '/warehouse_foundation/warehouse_goods/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 货主货品库存分页查询
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/15009
 */
 export function shipperGoods(data, params) {
    return otmsHttp.request({
        url: '/warehouse_management_system/shipper_goods_stock/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 货主SKU分页  出库
 * @param {object} data 列表查询参数
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/16489
 */
export function fetchSkuPageIn(data, params) {
    return wmsHttp.request({
        url: '/warehouse_management_system/sku/stock/page',
        method: 'post',
        data,
        params
    })
}

/**
 * 货主创建SKU
 * https://yapi.ops.yunlizhi.cn/project/194/interface/api/8746
 */
export function createSku(data) {
    return otmsHttp.request({
        url: '/customer/sku/create',
        method: 'post',
        data,
    })
}

/**
 * 容器库存分页查询
 * https://yapi.ops.yunlizhi.cn/project/382/interface/api/15199
 */

export function getStockPage(data, params) {
    return wmsHttp.post('/warehouse_management_system/stock/container_stock/page', data, { params })
}

/**
 * 货品品类列表
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/19265
 */

 export function getLevelTree() {
    return wmsHttp.post('/warehouse_foundation/goods_level/tree')
}

/**
 * 库位管理 分页查询
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/12022
 */
export function getStorehousePage(data) {
	return wmsHttp.post('/warehouse_management_system/stock/query_sum_goods_amount', data)
}

/**
 * 供应商
 * https://yapi.ops.yunlizhi.cn/project/388/interface/api/11350
 */
 export function getWarehouseDetail(data) {
	return wmsHttp.post('/warehouse_foundation/warehouse_goods/detail', data)
}
